import { AgeGroup, Unit } from "../../../constants/exportsCountries"
import { DOMESTIC_NUTRITION_KEYS } from "../../../Utils/constants"

export type IndiaMandatoryNutrientKey =
  | typeof DOMESTIC_NUTRITION_KEYS.ENERGY
  | typeof DOMESTIC_NUTRITION_KEYS.TOTAL_CARBOHYDRATE
  | typeof DOMESTIC_NUTRITION_KEYS.TOTAL_SUGARS
  | typeof DOMESTIC_NUTRITION_KEYS.ADDED_SUGARS
  | typeof DOMESTIC_NUTRITION_KEYS.PROTEIN
  | typeof DOMESTIC_NUTRITION_KEYS.SODIUM
  | typeof DOMESTIC_NUTRITION_KEYS.TOTAL_FAT
  | typeof DOMESTIC_NUTRITION_KEYS.TRANS_FAT
  | typeof DOMESTIC_NUTRITION_KEYS.SATURATED_FAT
  | typeof DOMESTIC_NUTRITION_KEYS.CHOLESTEROL

export type MandatoryNutrientObject = Partial<
  Record<IndiaMandatoryNutrientKey, string>
> & {
  [K in IndiaMandatoryNutrientKey as K extends
    | typeof DOMESTIC_NUTRITION_KEYS.TRANS_FAT
    | typeof DOMESTIC_NUTRITION_KEYS.SATURATED_FAT
    | typeof DOMESTIC_NUTRITION_KEYS.CHOLESTEROL
    ? never
    : K]: string
}
export type IndiaNutrientData = {
  key: string
  name: string
  per_100g: string
  per_serve: string
  rda: string
}

export type IndiaNutritionTableValue = {
  no_of_servings: number | ""
  serving_size: string
  serving_size_unit: Unit
  age_group: AgeGroup
  mandatory_nutrient: IndiaNutrientData[]
  non_mandatory_nutrient?: IndiaNutrientData[]
}

export const INDIA_NO_RDA_NUTRIENT_KEYS = [
  DOMESTIC_NUTRITION_KEYS.TOTAL_CARBOHYDRATE,
  DOMESTIC_NUTRITION_KEYS.TOTAL_SUGARS,
  DOMESTIC_NUTRITION_KEYS.CHOLESTEROL,
  DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE,
  DOMESTIC_NUTRITION_KEYS.MUFA,
  DOMESTIC_NUTRITION_KEYS.PUFA,
]
